/**
 * Hook to fetch a single approval workflow with full details
 */
import useSWR from "swr";
import { endpoints } from "../../../../../endpoints";
import type {
  ApprovalWorkflow,
  StageValidation,
} from "../../../../../types/types.Workflow";
import { useStoreState } from "../../../../../util/util";

export type AttributeInfo = {
  display_name: string;
  list_id?: string | null;
};

export type ApprovalAttributes = {
  [key: string]: AttributeInfo;
};

export function useApprovalDetail(approvalId: string | null) {
  const { storefront_id } = useStoreState();

  const { data, error, mutate, isValidating } = useSWR<{
    data: ApprovalWorkflow;
    stage_validation: StageValidation;
    attributes?: ApprovalAttributes;
  }>(
    storefront_id && approvalId
      ? endpoints.v2_storefronts_id_integrations_approvals_id(
          storefront_id,
          approvalId
        )
      : null
  );

  return {
    approval: data?.data,
    stageValidation: data?.stage_validation,
    attributes: data?.attributes,
    error,
    isLoading: !data && !error && !!approvalId,
    isValidating,
    mutate,
  };
}
